import styled from '@emotion/styled';

export const ModalMobileSpacer = styled.div`
  padding: 12px 1rem;
`;

export const ModalMobileInnerSpacer = styled.div`
  width: 100%;
  flex: 1 1 auto;
  padding: 12px 1rem;
`;
export const ModalDesktopInnerSpacer = styled.div`
  padding: 1rem 1.5rem;
  width: 100%;
`;
